"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_label_1 = require("@hotelplan/components.common.label");
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BaseRadioControl = styled_components_1.default.span((0, util_theme_sxc_1.sx2CssThemeFn)({
    height: ['25px', '20px'],
    width: ['25px', '20px'],
    position: 'relative',
    border: ['6px solid', '5px solid'],
    borderColor: ['borderColor', 'borderColor'],
    borderRadius: '50%',
    order: '-1',
    mr: [2, '10px'],
    backgroundColor: 'background',
}));
const BaseRadioInput = styled_components_1.default.input.attrs({
    type: `radio`,
})(components_common_mixins_1.visuallyHidden);
const RadioLabel = (0, styled_components_1.default)(components_common_label_1.Label)((0, util_theme_sxc_1.sx2CssThemeFn)(({ theme: { colors }, disabled }) => ({
    '.customRadioInput': {
        cursor: disabled ? 'default' : 'pointer',
    },
    '&:hover .input ~ .customRadioInput': {
        backgroundColor: disabled ? colors.background : colors.lightGreySecond,
    },
    '.input:checked ~ .customRadioInput': {
        borderColor: colors.background,
        backgroundColor: colors.primary,
        boxShadow: '0 0 0 1px #e1e1e1',
    },
    '.input:checked ~ .customRadioInput::after': {
        opacity: '1',
    },
})));
const RadioButton = props => {
    const { hideLabel = false, disabled = false, testId, labelTestId = '', content = '', onChange = noop_1.default, value = '', name, className, renderCustomControl = () => (react_1.default.createElement(BaseRadioControl, { className: "customRadioInput" })) } = props, inputProps = __rest(props, ["hideLabel", "disabled", "testId", "labelTestId", "content", "onChange", "value", "name", "className", "renderCustomControl"]);
    return (react_1.default.createElement(RadioLabel
    // @ts-ignore
    , { 
        // @ts-ignore
        disabled: disabled, hideLabel: hideLabel, className: className, "data-id": labelTestId },
        react_1.default.createElement(BaseRadioInput, Object.assign({ className: "input", name: name || value.toString(), onChange: (e) => onChange(e.target.value, e), value: value, disabled: disabled, "data-id": testId }, inputProps)),
        content,
        renderCustomControl(props)));
};
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map